import * as ResponsiveFns from '../utilities/ResponsiveFns';
import * as StyleFunctions from '../utilities/StyleFunctions';
import AllContents from './AllContents';
import React, {useRef, useEffect} from 'react';
import TabTopRowElement from './TabTopRowElement';

function App(props) {

  var thisItem = props.thisItem;
  var screenSelectionChoices = props.screenSelectionChoices;
  var itemInfoPathString = props.itemInfoPathString;
  var setScreenSelectionChoices = props.setScreenSelectionChoices;
  var interactionFn = props.interactionFn;
  var clickEditItem = props.clickEditItem;
  var itemInfoPath = props.itemInfoPath;
  var currentList = props.currentList;
  var internalVariables = props.internalVariables;
  var width = props.width;
  var height = props.height;
  var upwardInfo = props.upwardInfo;
  var inputValues = props.inputValues;
  var ownVariables = props.ownVariables;
  var urlParamsForExecution = props.urlParamsForExecution;
  var urlHeader = props.urlHeader;
  var addClassNames = props.addClassNames;
  var addWhereText = props.addWhereText;
  var setInputValues = props.setInputValues;
  var editPieces = props.editPieces;
  var organicChanges = props.organicChanges;
  var userNos = props.userNos;
  var userID = props.userID;
  var hoveringWhere = props.hoveringWhere;
  var actHoveringWhere = props.actHoveringWhere;
  var doAScreenRef = props.doAScreenRef;
  var popUps = props.popUps;
  var setPopUps = props.setPopUps;
  var allStyles = props.allStyles;
  var itemEdited = props.itemEdited;
  var setItemEdited = props.setItemEdited;
  var clickFn = props.clickFn;
  var stylesToAdd = props.stylesToAdd;
  var draggable = props.draggable;
  var onDragStart = props.onDragStart;
  var onDrag = props.onDrag;
  var onDragEnd = props.onDragEnd;
  var addCCColWidth = props.addCCColWidth;
  var potentiallyAddWhichItem = props.potentiallyAddWhichItem;
  var setIsClickingOnContentDiv = props.setIsClickingOnContentDiv;
  var isClickingOnContentDiv = props.isClickingOnContentDiv;
  var flashHighlight = props.flashHighlight;
  var chains = props.chains;
  var lastEdited = props.lastEdited;
  var counter = props.counter;

  const ref1 = useRef();

  useEffect(()=>{
    doAScreenRef(ref1, itemInfoPath);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

    var tabItems = thisItem.i;
    var tabItemKeys = ResponsiveFns.sortAListBasedOnOrd(tabItems);
    var whichTgt;
    if (tabItemKeys.length > 0){
      whichTgt = tabItemKeys[0];
      if (screenSelectionChoices[itemInfoPathString]){
        if (tabItems[screenSelectionChoices[itemInfoPathString]]){
          whichTgt = screenSelectionChoices[itemInfoPathString];
        }
      }
    }

    function clickTab(aTabKey){
      return function(e){
        screenSelectionChoices[itemInfoPathString] = aTabKey;
        setScreenSelectionChoices({...screenSelectionChoices});
        if (!interactionFn && clickEditItem){
          clickEditItem({t:'item', path:itemInfoPath.concat(['i', aTabKey])})(e);
        }
        e.stopPropagation();
      }
    }

    var generalTabStyles = StyleFunctions.evaluateStyleR('TABITEMSGENERAL', thisItem.s, itemInfoPath.concat(['s']), currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);

    var topRow = tabItemKeys.map((aTabKey, index)=>{
      var thisTab = tabItems[aTabKey];

      return <TabTopRowElement key={index} chains={chains} thisTab={thisTab} tabPath={itemInfoPath.concat(['i', aTabKey])} currentList={currentList} internalVariables={internalVariables} width={width} height={height} inputValues={inputValues} upwardInfo={upwardInfo} ownVariables={ownVariables} whichTgt={whichTgt} aTabKey={aTabKey} doAScreenRef={doAScreenRef} generalTabStyles={generalTabStyles} clickTab={clickTab} urlParamsForExecution={urlParamsForExecution}/>

    })
//
    var insideContents;
    if (tabItemKeys.length === 0){
      if (!interactionFn){
        var iss;
        if (addClassNames.indexOf(' editing') > -1 && addWhereText){
          iss = <p className='card-text'>+ Tab</p>
        }else{
          iss = <p className='card-text'>No Tabs</p>
//
        }
        topRow = <td>{iss}</td>
//
      }
    }else{
      var thisTab = tabItems[whichTgt];
      insideContents = <AllContents userID={userID} chains={chains} key={'tabItem'} height={height} width={width} currentList={currentList} internalVariables={internalVariables} interactionFn={interactionFn} inputValues={inputValues} setInputValues={setInputValues} itemEdited={itemEdited} setItemEdited={setItemEdited} thisItem={thisTab} itemInfoPath={itemInfoPath.concat(['i', whichTgt])} stylesToAdd={{}} editPieces={editPieces} needToShowError={true} clickEditItem={clickEditItem} addClassNames={''} dragStuff={false} parentalType={'TABS'} setIsClickingOnContentDiv={setIsClickingOnContentDiv} isClickingOnContentDiv={isClickingOnContentDiv} upwardInfo={upwardInfo} addWhereText={addWhereText} potentiallyAddWhichItem={potentiallyAddWhichItem} organicChanges={organicChanges} userNos={userNos} hoveringWhere={hoveringWhere} actHoveringWhere={actHoveringWhere} screenSelectionChoices={screenSelectionChoices} setScreenSelectionChoices={setScreenSelectionChoices} popUps={popUps} setPopUps={setPopUps} ownVariables={ownVariables} doAScreenRef={doAScreenRef} flashHighlight={flashHighlight} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} lastEdited={lastEdited} counter={counter}/>

    }
    var topRowStyle = {backgroundColor:allStyles.backgroundColor};
    delete allStyles.backgroundColor;
//

    //we treat this separately even though this is a holder because unlike holders we don't show everything at once.
    return <div ref={ref1} className={addClassNames + addCCColWidth} onClick={clickFn} style={{...stylesToAdd, ...allStyles}} draggable={draggable} onDragStart={onDragStart} onDrag={onDrag} onDragEnd={onDragEnd} onMouseOver={actHoveringWhere(itemInfoPathString)} onMouseOut={actHoveringWhere('')}><div className='container-fluid' style={topRowStyle}><div className='row'>{topRow}</div></div>{insideContents}</div>

}
//




export default App;
